import React, { FC, useState } from 'react'
import { Input } from 'antd'
import styles from './index.module.less'
import { IProps } from './const'

/**
 * 图片验证
 * @param account
 * @param onFinish
 * @constructor
 */
const CaptchaImage: FC<IProps> = ({ account = '1', onFinish }) => {
  const [k, setK] = useState(Math.random)
  return (
    <div className={styles.wrap}>
      <div className={styles.authCodeInput}>
        <Input
          placeholder="验证码"
          maxLength={4}
          onChange={({ target: { value } }) => {
            onFinish({
              captchaCode: value,
              reset: () => setK(Math.random)
            })
          }}
        />
      </div>
      <div
        className={styles.authCodeImg}
        onClick={() => {
          setK(Math.random)
        }}
      >
        <img
          src={`/open/znClientapi/agent/getSafeImgCaptcha.do?userName=${account}&k=${k}`}
          alt=""
        />
      </div>
    </div>
  )
}

export default CaptchaImage
